import React from "react";
import Navbar from "../../components/Navbar";
import Typography from "@mui/material/Typography";
import { Box, Container } from "@mui/material";
import "./PrivacyPolicy.scss";
import Footer from "../../components/Footer";

const PrivacyPolicy = () => {
  return (
    <>
      <Navbar />
      <Box className="privacy_policy">
        <Container maxWidth="lg">
          <Typography variant="h1" component="h1">
            Declaração de Privacidade Whasapp para Parceiros
          </Typography>
          <Typography variant="body1" component="p">
            Data de Vigência: 14/07/2024
          </Typography>
          <Typography variant="body1" component="p">
            A sua privacidade é importante para nós. Esta Política de
            Privacidade descreve como o WashPass coleta, usa, divulga e protege
            as informações pessoais dos usuários ao utilizar nosso aplicativo e
            serviços.
          </Typography>

          <Typography variant="body1" component="h2">
            1. Coleta de Informações
          </Typography>
          <Typography variant="body1" component="p">
            Coletamos diferentes tipos de informações para fornecer e melhorar
            nossos serviços:
          </Typography>
          <Typography variant="body1" component="h4">
            1.1 Informações Pessoais:
          </Typography>
          <ul>
            <li>Nome completo</li>
            <li>Endereço de e-mail</li>
            <li>Número de telefone</li>
            <li>Endereço residencial</li>
          </ul>
          <Typography variant="body1" component="h4">
            1.2 Informações do Veículo:
          </Typography>
          <ul>
            <li>Modelo do carro</li>
            <li>Placa do carro</li>
          </ul>
          <Typography variant="body1" component="h4">
            1.3 Informações de Uso:
          </Typography>
          <ul>
            <li>Dados de localização (com seu consentimento)</li>
            <li>Histórico de serviços e transações realizadas através do aplicativo</li>
            <li>Informações sobre como você usa o aplicativo (páginas visitadas, tempo gasto no aplicativo, etc.)</li>
          </ul>
          <Typography variant="body1" component="h4">
            1.4 Informações de Pagamento:
          </Typography>
          <ul>
            <li>Detalhes do cartão de crédito ou outras informações de pagamento necessárias para processar transações</li>
          </ul>

          <Typography variant="body1" component="h2">
            2. Uso das Informações
          </Typography>
          <Typography variant="body1" component="p">
            Usamos as informações coletadas para diversos fins:
          </Typography>
          <Typography variant="body1" component="h4">
            2.1 Fornecimento de Serviços:
          </Typography>
          <ul>
            <li>Processar e gerenciar suas reservas e pagamentos de serviços de lavagem automotiva</li>
            <li>Enviar confirmações, recibos e atualizações relacionadas aos serviços</li>
          </ul>
          <Typography variant="body1" component="h4">
            2.2 Comunicação:
          </Typography>
          <ul>
            <li>Responder a perguntas e solicitações</li>
            <li>Enviar notificações sobre promoções, atualizações e novos serviços (com seu consentimento)</li>
          </ul>
          <Typography variant="body1" component="h4">
            2.3 Melhoria dos Serviços:
          </Typography>
          <ul>
            <li>Analisar o uso do aplicativo para melhorar a experiência do usuário</li>
            <li>Personalizar o conteúdo e as recomendações com base nas suas preferências</li>
          </ul>

          <Typography variant="body1" component="h2">
            3. Compartilhamento de Informações
          </Typography>
          <Typography variant="body1" component="p">
            Não compartilhamos suas informações pessoais com terceiros, exceto:
          </Typography>
          <Typography variant="body1" component="h4">
            3.1 Parceiros de Serviço:
          </Typography>
          <ul>
            <li>Lava-jatos parceiros que realizam os serviços solicitados</li>
            <li>Processadores de pagamento para facilitar transações</li>
          </ul>
          <Typography variant="body1" component="h4">
            3.2 Cumprimento da Lei:
          </Typography>
          <ul>
            <li>Quando exigido por lei ou para responder a processos legais</li>
            <li>Para proteger nossos direitos, privacidade, segurança ou propriedade</li>
          </ul>

          <Typography variant="body1" component="h2">
            4. Proteção das Informações
          </Typography>
          <Typography variant="body1" component="p">
            Adotamos medidas de segurança adequadas para proteger suas informações contra acesso não autorizado, alteração, divulgação ou destruição. No entanto, nenhuma transmissão de dados pela internet ou sistema de armazenamento eletrônico é 100% segura.
          </Typography>

          <Typography variant="body1" component="h2">
            5. Seus Direitos
          </Typography>
          <Typography variant="body1" component="p">
            Você tem o direito de:
          </Typography>
          <Typography variant="body1" component="h4">
            5.1 Acessar e Atualizar:
          </Typography>
          <ul>
            <li>Acessar e atualizar suas informações pessoais a qualquer momento através do aplicativo</li>
          </ul>
          <Typography variant="body1" component="h4">
            5.2 Excluir Conta:
          </Typography>
          <ul>
            <li>Solicitar a exclusão de sua conta e informações pessoais. Note que podemos reter certas informações conforme exigido por lei ou para fins comerciais legítimos.</li>
          </ul>

          <Typography variant="body1" component="h2">
            6. Alterações nesta Política de Privacidade
          </Typography>
          <Typography variant="body1" component="p">
            Podemos atualizar esta Política de Privacidade periodicamente. Notificaremos você sobre quaisquer alterações publicando a nova política no aplicativo e, quando apropriado, enviaremos uma notificação por e-mail.
          </Typography>

          <Typography variant="body1" component="h2">
            7. Contato
          </Typography>
          <Typography variant="body1" component="p">
            Se você tiver dúvidas sobre esta Política de Privacidade, entre em contato conosco através do e-mail contato@wash.app.br.
          </Typography>
        </Container>
      </Box>
      <Footer />
    </>
  );
};

export default PrivacyPolicy;
